/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateWeightClassDto } from '../model';
// @ts-ignore
import type { UpsertWeightClassSetsCommand } from '../model';
// @ts-ignore
import type { WeightClassDto } from '../model';
// @ts-ignore
import type { WeightClassSetResponseDto } from '../model';
/**
 * WeightClassesApi - axios parameter creator
 */
export const WeightClassesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<CreateWeightClassDto>} [createWeightClassDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weightClassesCreate: async (createWeightClassDto?: Array<CreateWeightClassDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/WeightClasses/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWeightClassDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weightClassesGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/WeightClasses/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weightClassesGetAllWeightClassSets: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/WeightClasses/GetAllWeightClassSets/GetAllWeightClassSets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertWeightClassSetsCommand} [upsertWeightClassSetsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weightClassesUpsertWeightClassSets: async (upsertWeightClassSetsCommand?: UpsertWeightClassSetsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/WeightClasses/UpsertWeightClassSets/UpsertWeightClassSets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertWeightClassSetsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WeightClassesApi - functional programming interface
 */
export const WeightClassesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WeightClassesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<CreateWeightClassDto>} [createWeightClassDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async weightClassesCreate(createWeightClassDto?: Array<CreateWeightClassDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.weightClassesCreate(createWeightClassDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WeightClassesApi.weightClassesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async weightClassesGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WeightClassDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.weightClassesGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WeightClassesApi.weightClassesGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async weightClassesGetAllWeightClassSets(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WeightClassSetResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.weightClassesGetAllWeightClassSets(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WeightClassesApi.weightClassesGetAllWeightClassSets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertWeightClassSetsCommand} [upsertWeightClassSetsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async weightClassesUpsertWeightClassSets(upsertWeightClassSetsCommand?: UpsertWeightClassSetsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.weightClassesUpsertWeightClassSets(upsertWeightClassSetsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WeightClassesApi.weightClassesUpsertWeightClassSets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WeightClassesApi - factory interface
 */
export const WeightClassesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WeightClassesApiFp(configuration)
    return {
        /**
         * 
         * @param {WeightClassesApiWeightClassesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weightClassesCreate(requestParameters: WeightClassesApiWeightClassesCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.weightClassesCreate(requestParameters.createWeightClassDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weightClassesGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<WeightClassDto>> {
            return localVarFp.weightClassesGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weightClassesGetAllWeightClassSets(options?: RawAxiosRequestConfig): AxiosPromise<Array<WeightClassSetResponseDto>> {
            return localVarFp.weightClassesGetAllWeightClassSets(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WeightClassesApiWeightClassesUpsertWeightClassSetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weightClassesUpsertWeightClassSets(requestParameters: WeightClassesApiWeightClassesUpsertWeightClassSetsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.weightClassesUpsertWeightClassSets(requestParameters.upsertWeightClassSetsCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for weightClassesCreate operation in WeightClassesApi.
 */
export interface WeightClassesApiWeightClassesCreateRequest {
    readonly createWeightClassDto?: Array<CreateWeightClassDto>
}

/**
 * Request parameters for weightClassesUpsertWeightClassSets operation in WeightClassesApi.
 */
export interface WeightClassesApiWeightClassesUpsertWeightClassSetsRequest {
    readonly upsertWeightClassSetsCommand?: UpsertWeightClassSetsCommand
}

/**
 * WeightClassesApi - object-oriented interface
 */
export class WeightClassesApi extends BaseAPI {
    /**
     * 
     * @param {WeightClassesApiWeightClassesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public weightClassesCreate(requestParameters: WeightClassesApiWeightClassesCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return WeightClassesApiFp(this.configuration).weightClassesCreate(requestParameters.createWeightClassDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public weightClassesGetAll(options?: RawAxiosRequestConfig) {
        return WeightClassesApiFp(this.configuration).weightClassesGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public weightClassesGetAllWeightClassSets(options?: RawAxiosRequestConfig) {
        return WeightClassesApiFp(this.configuration).weightClassesGetAllWeightClassSets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WeightClassesApiWeightClassesUpsertWeightClassSetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public weightClassesUpsertWeightClassSets(requestParameters: WeightClassesApiWeightClassesUpsertWeightClassSetsRequest = {}, options?: RawAxiosRequestConfig) {
        return WeightClassesApiFp(this.configuration).weightClassesUpsertWeightClassSets(requestParameters.upsertWeightClassSetsCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

